export const VEHICLE_TYPES = { pl: "Poids lourd (PL)", car: "Voiture", tp: "Engin TP" };

export const emptyVehicle = {
  brand: "", model: "", year: "", registration: "", vin: "", serialNumber: "",
  engine: "", identifierUnknown: false,
};

export const emptyForm = {
  name: "", phone: "", vehicleType: "", ...emptyVehicle,
  part: "", email: "", reference: "", message: "",
};

// Keep vehicle details in the existing message field, which is persisted,
// displayed in the team's request dashboard and included in notifications.
export function buildRequestPayload(form) {
  const v = Object.fromEntries(Object.entries(form).map(([key, value]) =>
    [key, typeof value === "string" ? value.trim() : value]));
  if (!VEHICLE_TYPES[v.vehicleType] || ![v.name, v.phone, v.brand, v.model, v.part].every(Boolean)) {
    throw new Error("Complétez votre nom, téléphone, type de véhicule, marque, modèle et pièce recherchée.");
  }
  const isTP = v.vehicleType === "tp";
  if (!v.identifierUnknown && !(isTP ? v.serialNumber : v.registration)) {
    throw new Error(isTP ? "Indiquez le numéro de série ou cochez « Je ne connais pas ce numéro »." : "Indiquez l’immatriculation ou cochez « Je ne connais pas l’immatriculation »." );
  }
  if (!/^\+?[0-9 .()\-]+$/.test(v.phone) || !/^\d{8,15}$/.test(v.phone.replace(/\D/g, ""))) {
    throw new Error("Indiquez un numéro de téléphone complet pour que nous puissions vous joindre.");
  }
  const year = Number(v.year);
  if (v.year && (!/^\d{4}$/.test(v.year) || year < 1900 || year > new Date().getFullYear() + 1)) {
    throw new Error("Vérifiez l’année du véhicule ou de l’engin.");
  }
  return {
    name: v.name, phone: v.phone, email: v.email || null,
    designation: v.part, reference: v.reference || null,
    message: [
      "Demande de devis — site Easy Pièces",
      `Type de véhicule : ${VEHICLE_TYPES[v.vehicleType]}`,
      `Marque : ${v.brand}`, `Modèle : ${v.model}`,
      v.year && `Année : ${v.year}`,
      isTP
        ? `N° de série / PIN : ${v.identifierUnknown ? "Non connu — à préciser avec le client" : v.serialNumber.toUpperCase()}`
        : `Immatriculation : ${v.identifierUnknown ? "Non connue — à préciser avec le client" : v.registration.toUpperCase()}`,
      !isTP && v.vin && `N° de châssis / VIN : ${v.vin.toUpperCase()}`,
      v.engine && `${isTP ? "Modèle / référence moteur" : "Motorisation"} : ${v.engine}`,
      `Pièce : ${v.part}`,
      v.reference && `Référence : ${v.reference}`,
      v.message && `Précisions : ${v.message}`,
    ].filter(Boolean).join("\n"),
  };
}
